import { useLocation } from 'react-router-dom';
import { TTabname } from '..';

const useTabSelected = () => {
	const { pathname } = useLocation();
	const tabSelected = pathname.split('/').reverse()[0] as TTabname;
	const title =
		tabSelected === 'overview'
			? `Vue d'ensemble`
			: tabSelected === 'users'
			? `Utilisateurs`
			: `Transactions`;

	return {
		tabSelected,
		title,
	};
};

export default useTabSelected;